import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/demos/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/app/admin/demos/sets" />;
}
